// AutoCAD Color Index (ACI) — hex renk tablosu
// Standart renkler (1-9), grid renkleri (10-249), gri tonlari (250-255)

function hsvToHex(h, s, v) {
  h = ((h % 360) + 360) % 360;
  const c = v * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = v - c;
  let r, g, b;
  if (h < 60)       { r = c; g = x; b = 0; }
  else if (h < 120) { r = x; g = c; b = 0; }
  else if (h < 180) { r = 0; g = c; b = x; }
  else if (h < 240) { r = 0; g = x; b = c; }
  else if (h < 300) { r = x; g = 0; b = c; }
  else               { r = c; g = 0; b = x; }
  const toHex = (n) => Math.round((n + m) * 255).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

// Standart renkler 1-9
const STANDARD_COLORS = {
  1: '#FF0000',
  2: '#FFFF00',
  3: '#00FF00',
  4: '#00FFFF',
  5: '#0000FF',
  6: '#FF00FF',
  7: '#FFFFFF',
  8: '#808080',
  9: '#C0C0C0',
};

// Gri tonlari 250-255
const GRAY_COLORS = {
  250: '#333333',
  251: '#505050',
  252: '#696969',
  253: '#828282',
  254: '#BEBEBE',
  255: '#FFFFFF',
};

// Grid renkleri 10-249
// 24 sutun (hue) x 10 satir (parlaklik/doygunluk)
// Satir duzeni: [saturation, value]
const GRID_ROWS = [
  [1.0, 1.0],
  [0.5, 1.0],
  [1.0, 0.80],
  [0.5, 0.80],
  [1.0, 0.60],
  [0.5, 0.60],
  [1.0, 0.40],
  [0.5, 0.40],
  [1.0, 0.20],
  [0.5, 0.20],
];

const GRID_COLS = 24;

function generateAciTable() {
  const table = { ...STANDARD_COLORS, ...GRAY_COLORS };
  for (let col = 0; col < GRID_COLS; col++) {
    const hue = col * 15; // 0, 15, 30, ... 345
    for (let row = 0; row < GRID_ROWS.length; row++) {
      const [s, v] = GRID_ROWS[row];
      const aci = 10 + col * 10 + row;
      table[aci] = hsvToHex(hue, s, v);
    }
  }
  return table;
}

export const ACI_TABLE = generateAciTable();

// ACI indeksinden hex renk al
export function aciToHex(index) {
  return ACI_TABLE[index] || '#FFFFFF';
}

// Hex renkten en yakin ACI indeksini bul
export function hexToAci(hex) {
  const target = hex.toLowerCase();
  for (const [aci, color] of Object.entries(ACI_TABLE)) {
    if (color.toLowerCase() === target) return Number(aci);
  }
  return 7; // default white
}

// Grid verisi: { aci, hex } dizisi (satir x sutun)
export function getAciGrid() {
  const grid = [];
  for (let row = 0; row < GRID_ROWS.length; row++) {
    const rowData = [];
    for (let col = 0; col < GRID_COLS; col++) {
      const aci = 10 + col * 10 + row;
      rowData.push({ aci, hex: ACI_TABLE[aci] });
    }
    grid.push(rowData);
  }
  return grid;
}

// Standart renkler dizisi
export function getStandardColors() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9].map(aci => ({ aci, hex: ACI_TABLE[aci] }));
}

// Gri tonlari dizisi
export function getGrayColors() {
  return [250, 251, 252, 253, 254, 255].map(aci => ({ aci, hex: ACI_TABLE[aci] }));
}
